import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/auth/restore`

const restore = (data: { email: string }): AxiosPromise => apiFetch(URL, { data, method: `POST` })

export default restore
